var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"watchlist_placeholder"}},[_c('table',{staticClass:"row-table"},[_c('tr',[_c('td',{staticClass:"check"}),_c('td',[_vm._v(_vm._s(_vm.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }